<template>
    <div id="fabric-js-container" ref="fabricJSContainer">
        <canvas id="fabric-js-canvas" class="workspace-module-container" ref="fabricJS"></canvas>
    </div>
</template>

<script>
    import {urlForFileStorage} from "../common";
    import {fabricEditor} from "../../fabric/fabricMain";
    import store from "../../store";
    import {bus} from "../../vue_bus";
    import {threeMain} from "../../threeJS/threeMain";
    import {getScale} from "../../fabric/libs/common";

    export default {
        name: "WorkspaceFabric.vue",
        mixins: [urlForFileStorage],
        mounted() {
            this.initFabric();
            bus.$on("selectedPlaneFromPlaneVisualisator", (planeID) => {
                if (this.$route.name === "planeCategories" || this.$route.name === "planeCategoriesActiveSelection")
                    if (planeID !== this.$route.params.planeID) {
                        this.$router.replace({
                            name: "planeCategoriesActiveSelection",
                            params: {planeID: planeID},
                            query: this.$route.query
                        }).catch(() => {
                        });
                    }
                if(this.$route.name === 'planeCategoriesForPerspective' || this.$route.name === 'planeCategoriesForPerspectiveActivePlane') {
                    this.$router.replace({
                        name: "planeCategoriesForPerspectiveActivePlane",
                        params: {planeID: planeID},
                        query: this.$route.query
                    }).catch(() => {
                    });
                }
            })
            bus.$on("unSelectedPlaneFromPlaneVisualisator", () => {
                if(this.$route.name === 'planeCategoriesForPerspectiveActivePlane') {
                    this.$router.replace({
                        name: "planeCategoriesForPerspective",
                        query: this.$route.query
                    }).catch(() => {
                    });
                }
            })
            bus.$on("dblclickPlaneFromPlaneVisualisator", (planeID) => {
                if (this.$route.name === "planeCategoriesForPerspective" || this.$route.name === 'planeCategoriesForPerspectiveActivePlane') {
                    this.$router.push({
                        name: "SetPerspective",
                        params: {planeID: planeID},
                        query: this.$route.query
                    }).catch(() => {
                    });
                } else if (this.$route.name === "planeCategories" || this.$route.name === "planeCategoriesActiveSelection") {
                    let name = this.$store.getters["active/PLANE_BY_ID"](planeID).type;
                    if (this.$store.getters["active/PLANE_BY_ID"](planeID).type === "additional")
                        name = "additionalManual";

                    this.$router.push({
                        name: name,
                        params: {planeID: planeID},
                        query: this.$route.query
                    }).catch(() => {
                    });
                }
            })
            bus.$on('refreshFabric', () => {
                this.editor.destroy();
                this.initFabric();
            })
        },
        destroyed() {
            bus.$off("dblclickPlaneFromPlaneVisualisator");
            bus.$off("selectedPlaneFromPlaneVisualisator");
            bus.$off("refreshFabric");
            this.editor.destroy();
        },
        computed: {
            activePhotoAbsoluteURL() {
                return this.urlForFileStorage(this.$store.getters[`active/GET_ACTIVE_PHOTO`].src);
            }
        },
        methods: {
            initFabric: async function () {
                this.editor = new fabricEditor(this.$refs["fabricJS"]);
                this.editor.updateCanvaSize({
                        width: this.$refs["fabricJSContainer"].offsetWidth,
                        height: this.$refs["fabricJSContainer"].offsetHeight
                    }
                )
                let source = await this.editor.addSourceImage(this.activePhotoAbsoluteURL);
                // let size = await this.$store.dispatch("active/GET_ACTIVE_IMG_SIZE");
                // let scale = getScale(size, this.editor.fabricJS);
                // console.log(scale)
                await this.editor.showPlanes();
                this.editor.setViewport(source, 1);
            }
        }
    }
</script>

<style scoped>
    #fabric-js-container {
        width: 100%;
        height: 100%;
    }
</style>
